import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexContainer, FlexRow } from 'styles/layouts';

export const Container = styled(FlexContainer)<{
  direction: 'row' | 'column';
  alignItems?: string;
}>`
  flex-direction: ${({ direction }) => direction};
  min-width: 368px;
  width: 100%;
  gap: 24px;
  padding: 18px;
  border-radius: ${themeStyle.radiusLarge};
  box-shadow: ${themeStyle.shadowMedium};
  position: relative;
  background: ${themeStyle.varBackgroundAlt};

  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'flex-start')};

  ${QUERIES.tabletAndUp} {
    max-width: 546px;
    width: 100%;
  }

  @media (max-width: 399px) {
    min-width: auto;
    width: 100%;
  }
`;

export const FlexRowCol = styled(FlexRow)<{ width?: string }>`
  width: ${({ width }) => width || 'auto'};
  justify-content: right;
  gap: 8px;

  align-items: center;
  margin-left: auto;
`;
